const cafeeConfig = {
  businessName: "Brew & Bloom Café",
  businessCategory: "Café & Coffee House",
  productsLabel: "Our Menu",
  tagline: "Where Every Sip Tells a Story",
  description: "Brew & Bloom is a cozy artisan cafeé serving handcrafted coffees, fresh pastries, and wholesome meals in a warm, welcoming atmosphere.",
  mission: "To create a comforting space where great coffee meets great conversations.",
  vision: "To be the most loved neighbourhood cafeé, one cup at a time.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#6f4e37",
    secondaryColor: "#c8a97e",
    accentColor: "#f5cba7",
    backgroundColor: "#fffdf9",
    textColor: "#2c1a0e",
    darkBackground: "#1a0f07",
    darkText: "#f5e6d3",
    borderRadius: "16px",
    fontFamily: "'Inter', 'Georgia', serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "Brew & Bloom Café | Artisan Coffee & Pastries",
    description: "Visit Brew & Bloom for handcrafted coffees, fresh pastries, and a cozy atmosphere. Perfect for work, dates, or relaxing.",
    keywords: "cafee, coffee, pastries, artisan, brew, latte, cappuccino",
    ogImage: "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98765 11111",
    whatsapp: "919876511111",
    email: "hello@brewandbloom.com",
    website: "www.brewandbloom.com",
    address: "42, Coffee Lane, Bandra West, Mumbai - 400050",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08250589563531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Monday – Friday", hours: "7:00 AM – 10:00 PM" },
    { day: "Saturday – Sunday", hours: "8:00 AM – 11:00 PM" },
  ],
  social: { facebook: "https://facebook.com", instagram: "https://instagram.com", linkedin: "", youtube: "", twitter: "https://twitter.com" },
  hero: {
    heading: "Life is Too Short for Bad Coffee",
    subheading: "Handcrafted brews, fresh-baked pastries, and a cozy corner just for you.",
    ctaPrimary: { label: "View Our Menu", link: "/cafee/services" },
    ctaSecondary: { label: "Find Us", link: "/cafee/contact" },
    images: [
      "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=1400&q=80",
      "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1400&q=80",
      "https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=1400&q=80",
    ],
  },
  about: {
    heading: "Our Story",
    subheading: "Brewing Happiness Since 2018",
    body: "Born from a love of great coffee and warm spaces, Brew & Bloom started as a small corner cafeé and grew into a beloved community hub. Every bean is sourced ethically, every pastry baked fresh daily.",
    highlights: ["Single-Origin Beans", "Freshly Baked Daily", "Vegan Options Available", "Free Wi-Fi & Cozy Seating"],
    image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&q=80",
  },
  services: [
    { id: 1, icon: "FaLeaf", title: "Specialty Coffee", description: "Espresso, pour-over, cold brew, and seasonal specials crafted by our expert baristas.", image: "" },
    { id: 2, icon: "FaUtensils", title: "Fresh Pastries", description: "Croissants, muffins, cakes, and artisan breads baked fresh every morning.", image: "" },
    { id: 3, icon: "FaCalendarAlt", title: "Breakfast & Brunch", description: "Wholesome breakfast bowls, avocado toasts, and weekend brunch specials.", image: "" },
    { id: 4, icon: "FaHome", title: "Private Events", description: "Book our cafeé for birthdays, team meetings, or intimate gatherings.", image: "" },
    { id: 5, icon: "FaShieldAlt", title: "Loyalty Program", description: "Earn points on every purchase and enjoy free drinks and exclusive offers.", image: "" },
    { id: 6, icon: "FaMobileAlt", title: "Online Orders", description: "Order ahead via our app for quick pickup or home delivery.", image: "" },
  ],
  stats: [
    { value: 500, label: "Cups Served Daily", suffix: "+" },
    { value: 6, label: "Years of Brewing", suffix: "+" },
    { value: 30, label: "Menu Items", suffix: "+" },
    { value: 4.9, label: "Average Rating", suffix: "★" },
  ],
  whyUs: {
    heading: "Why Guests Love Us",
    subheading: "More than a cafeé — a community",
    points: [
      { icon: "FaLeaf", title: "Ethically Sourced", description: "All our beans are sourced directly from sustainable farms." },
      { icon: "FaShieldAlt", title: "Always Fresh", description: "Pastries and food prepared fresh every single day, no exceptions." },
      { icon: "FaHome", title: "Cozy Ambience", description: "Warm lighting, comfortable seating, and a welcoming vibe." },
      { icon: "FaCalendarAlt", title: "Community Events", description: "Open mic nights, art showcases, and coffee tasting sessions." },
    ],
  },
  gallery: [
    { id: 1, src: "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=800&q=80", alt: "Café Interior", category: "Ambience" },
    { id: 2, src: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80", alt: "Latte Art", category: "Coffee" },
    { id: 3, src: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&q=80", alt: "Cozy Corner", category: "Ambience" },
    { id: 4, src: "https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=800&q=80", alt: "Brewing Process", category: "Coffee" },
    { id: 5, src: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=800&q=80", alt: "Espresso Shot", category: "Coffee" },
    { id: 6, src: "https://images.unsplash.com/photo-1464305795204-6f5bbfc7fb81?w=800&q=80", alt: "Pastry Display", category: "Food" },
  ],
  pricing: [
    { id: 1, name: "Classic", price: "₹150", period: "per cup", features: ["Espresso / Americano", "Cappuccino / Latte", "Hot Chocolate", "Seasonal Specials"], highlighted: false },
    { id: 2, name: "Combo Meal", price: "₹350", period: "per person", features: ["Any Coffee", "Pastry of Choice", "Fresh Juice", "Free Refill"], highlighted: true },
    { id: 3, name: "Monthly Pass", price: "₹1,999", period: "per month", features: ["30 Coffees/Month", "10% Off Food", "Priority Seating", "Birthday Treat"], highlighted: false },
  ],
  testimonials: [
    { id: 1, name: "Sneha Kapoor", role: "Regular Customer", review: "Best coffee in the city! The ambience is so cozy and the staff is always so warm and friendly.", rating: 5, avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80" },
    { id: 2, name: "Rohan Desai", role: "Food Blogger", review: "Their croissants are absolutely divine. I come here every weekend without fail. Highly recommended!", rating: 5, avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80" },
    { id: 3, name: "Ananya Singh", role: "Work-from-Café Regular", review: "Perfect spot to work remotely. Great Wi-Fi, amazing coffee, and the playlist is always on point.", rating: 5, avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80" },
  ],
  team: [
    { id: 1, name: "Arjun Mehta", role: "Head Barista", bio: "Certified Q-Grader with a passion for single-origin brews.", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 2, name: "Priya Nair", role: "Pastry Chef", bio: "Trained in Paris, bringing French baking to your neighbourhood.", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 3, name: "Karan Shah", role: "Café Manager", bio: "Ensuring every visit is a memorable experience.", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
  ],
  faq: [
    { id: 1, question: "Do you have vegan options?", answer: "Yes! We offer oat milk, almond milk, and a dedicated vegan pastry selection." },
    { id: 2, question: "Can I book the cafeé for private events?", answer: "Absolutely. We host private events for up to 40 guests. Contact us to check availability." },
    { id: 3, question: "Do you offer home delivery?", answer: "Yes, we deliver within a 5km radius. Order via our app or call us directly." },
    { id: 4, question: "Is there parking available?", answer: "Street parking is available nearby, and we validate parking at the adjacent mall." },
  ],
  cta: { heading: "Come In, Stay Awhile", subheading: "Your perfect cup is waiting. Visit us today or order online.", buttonLabel: "View Our Menu", buttonLink: "/cafee/services" },
  footer: {
    tagline: "Where Every Sip Tells a Story.",
    copyright: `© ${new Date().getFullYear()} Brew & Bloom Café. All Rights Reserved.`,
    links: [
      { label: "Home", path: "/cafee" },
      { label: "Menu", path: "/cafee/services" },
      { label: "Gallery", path: "/cafee/gallery" },
      { label: "Contact", path: "/cafee/contact" },
    ],
  },
  products: [
    { id: 1, name: "Signature Cold Brew", category: "Coffee", price: 220, originalPrice: null, image: "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=600&q=80", description: "18-hour slow-steeped cold brew, served over ice with a hint of vanilla.", badge: "Best Seller", inStock: true },
    { id: 2, name: "Avocado Toast", category: "Food", price: 280, originalPrice: 320, image: "https://images.unsplash.com/photo-1541519227354-08fa5d50c820?w=600&q=80", description: "Sourdough toast, smashed avocado, cherry tomatoes, poached egg, microgreens.", badge: "Chef's Pick", inStock: true },
    { id: 3, name: "Croissant Combo", category: "Bakery", price: 199, originalPrice: 250, image: "https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=600&q=80", description: "Freshly baked butter croissant with your choice of coffee — a perfect morning pair.", badge: "Morning Special", inStock: true },
    { id: 4, name: "Matcha Latte", category: "Coffee", price: 250, originalPrice: null, image: "https://images.unsplash.com/photo-1536256263959-770b48d82b0a?w=600&q=80", description: "Ceremonial grade matcha whisked with oat milk, lightly sweetened.", badge: "New", inStock: true },
  ],
  sections: { hero: true, about: true, services: true, whyUs: true, stats: true, gallery: true, pricing: true, testimonials: true, team: true, faq: true, cta: true, contact: true, products: true, enquireMode: false },
};

export default cafeeConfig;
